import { useDispatch } from "react-redux";
import { setBusStaitionsOnMap, setBusStations, setDate, setMapMode, setRoadmaps, setVehTransports } from "../store/mapScreenSlce";
import { closeNavTab } from "../../../shared/components/NavTab/fuctionsControl";
function useMode() {
    const dispatch = useDispatch();

    function onRoadmapsMode() {
        dispatch(setMapMode('roadMaps'))
        //TODO сделать доп слушателя на фетч остановок
        // тк если пользоватль переключается раньше, чем произошла загрузка, они подгружаются на карту
        dispatch(setBusStaitionsOnMap([]));
        setTimeout(() => {
            dispatch(setBusStaitionsOnMap([]));
        }, 3000)
        // dispatch(setBusStations([]))
        dispatch(setVehTransports([]))
        dispatch(setRoadmaps([]));
        closeNavTab();
    }
    function onBusStopMode() {
        dispatch(setMapMode('busStops'))
        dispatch(setDate(new Date()))
        dispatch(setRoadmaps([]))
        // dispatch(setBusStations([]))
        dispatch(setVehTransports([]))
        dispatch(setRoadmaps([]))
        closeNavTab();
    }

    return {
        onRoadmapsMode,
        onBusStopMode,
    }

}

export default useMode;